import {FC, useState} from 'react'
import SpecialSelectionModal from './SpecialSelectionModal'
import SharedData from '../../../common/SharedData'
import {useIntl} from 'react-intl'

type IProps = {
  products_id: number[]
}

const SpecialSelectionSubmit: FC<IProps> = ({products_id}) => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <div className='aos-submitbar'>
        <div className='aos-selected'>
          <span className='aos-selected-badge'>
            <i className='fas fa-check' aria-hidden='true' />
          </span>
          <span>
            {products_id.length} {formatMessage({id: 'selected_prods'})}
          </span>
        </div>
        <button disabled={products_id.length === 0} className='aos-add-btn' onClick={toggleModal}>
          {formatMessage({id: 'add_discount'})}
          <i className='fas fa-tag' aria-hidden='true' />
        </button>
      </div>
      {isModalOpen && (
        <SpecialSelectionModal
          language={language}
          currentUser={currentUser}
          products_id={products_id}
          onCloseModal={toggleModal}
        />
      )}
    </>
  )
}

export default SpecialSelectionSubmit
